import React from 'react';
import { includes } from 'ramda';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import {
  LINE_ITEM_UNITS3,
  LINE_ITEM_BARBECUE_FEE,
  LINE_ITEM_JACUZZI_FEE,
  LINE_ITEM_LUNCH_CHILD_FEE,
  LINE_ITEM_LUNCH_ADULT_FEE,
  LINE_ITEM_SNACK_FEE,
  LINE_ITEM_TOWELS_FEE,
  LINE_ITEM_DINER_ADULT_FEE,
  LINE_ITEM_DINER_CHILD_FEE,
  LINE_ITEM_EVENING_FEE,
  propTypes,
} from '../../util/types';

import css from './BookingBreakdown.css';

const LineItemUnitPriceMaybe = props => {
  const { transaction, translationKey, unitType, intl } = props;

  const unitPurchase = transaction.attributes.lineItems.find(
    item => item.code === unitType && !item.reversal
  );

  if (includes(unitType, [
    LINE_ITEM_UNITS3,
    LINE_ITEM_BARBECUE_FEE,
    LINE_ITEM_SNACK_FEE,
    LINE_ITEM_TOWELS_FEE,
    LINE_ITEM_JACUZZI_FEE,
    LINE_ITEM_LUNCH_CHILD_FEE,
    LINE_ITEM_LUNCH_ADULT_FEE,
    LINE_ITEM_DINER_ADULT_FEE,
    LINE_ITEM_DINER_CHILD_FEE,
    LINE_ITEM_EVENING_FEE,
  ]) && !unitPurchase) return null;

  const formattedUnitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  
  const quantity = unitPurchase.quantity;

  if (parseInt(quantity) === 0) return null;

  return formattedUnitPrice ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={translationKey} />
      </span>
      <span className={css.itemValue}>{formattedUnitPrice}</span>
    </div>
  ) : null;
};

LineItemUnitPriceMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  unitType: propTypes.bookingUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemUnitPriceMaybe;



// WEBPACK FOOTER //
// ./src/components/BookingBreakdown/LineItemUnitPriceMaybe.js